export enum LeaveYear {
	CalendarYear = -1,
	Fixed = -2,
	FromFirstUsage = -3,
	Rolling = -4,
	DateOfHire = -5
}